module.exports = __webpack_public_path__ + "img/Food Donations .af043b12.jpg";